module.exports = __webpack_public_path__ + "static/img/pro10_tab3.8e826c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro10_tab3.jpg
// module id = hml7
// module chunks = 171